<template>
  <section
    class="base-modal"
    :style="{
      zIndex,
    }"
  >
    <slot></slot>
  </section>
</template>

<script>
export default {
  name: 'BaseModal',
  props: {
    showMode: {
      type: String,
      default: 'all',
    },
    pagesToInclude: {
      type: Array,
      default() {
        return [];
      },
    },
    pagesToExclude: {
      type: Array,
      default() {
        return [];
      },
    },
    showOnDesk: {
      type: Boolean,
      default: true,
    },
    showOnMobile: {
      type: Boolean,
      default: true,
    },
    showDisplayConfig: {
      type: Boolean,
      default: false,
    },
    showRecurrence: {
      type: Boolean,
      default: false,
    },
    displayStartsOn: {
      type: String,
      default: '',
    },
    displayEndsOn: {
      type: String,
      default: '',
    },
    startTime: {
      type: String,
      default: '',
    },
    endTime: {
      type: String,
      default: '',
    },
    zIndex: {
      type: String,
      default: '',
    },
  },
  metadata: {
    tabs: [
      {
        name: 'content',
        label: 'Conteúdo',
        groups: [
          {
            name: 'pageSelect',
            label: 'Seleção de páginas',
            fields: [
              {
                name: 'showMode',
                type: 'VueSelect',
                label: 'Configuração de seleção',
                default: 'all',
                options: [
                  {
                    label: 'Exibir pop-up em todas páginas',
                    value: 'all',
                  },
                  {
                    label: 'Exibir nas páginas selecionadas',
                    value: 'include',
                  },
                  {
                    label: 'Não exibir nas páginas selecionadas',
                    value: 'exclude',
                  },
                ],
              },
              {
                name: 'pagesToInclude',
                type: 'Tags',
                label: 'Exibir nas páginas:',
                helpText: 'Digite ou clique para buscar a página',
                placeholder: 'Clique para selecionar',
                whitelistFromPages: true,
                isEnabled({ showMode }) {
                  return showMode === 'include';
                },
              },
              {
                name: 'pagesToExclude',
                type: 'Tags',
                label: 'Não exibir nas páginas:',
                helpText: 'Digite ou clique para buscar a página',
                placeholder: 'Clique para selecionar',
                whitelistFromPages: true,
                isEnabled({ showMode }) {
                  return showMode === 'exclude';
                },
              },
            ],
          },
          {
            name: 'display',
            label: 'Período de exibição',
            fields: [
              {
                name: 'showDisplayConfig',
                type: 'Checkbox',
                label: 'Definir período de exibição',
              },
              {
                name: 'displayStartsOn',
                type: 'DatetimePicker',
                label: 'Início do período de exibição',
                enableTime: true,
                isEnabled({ showDisplayConfig }) {
                  return showDisplayConfig;
                },
              },
              {
                name: 'displayEndsOn',
                type: 'DatetimePicker',
                label: 'Fim do período de exibição',
                enableTime: true,
                isEnabled({ showDisplayConfig }) {
                  return showDisplayConfig;
                },
              },
              {
                name: 'showRecurrence',
                type: 'Checkbox',
                label: 'Definir horário de recorrência',
              },
              {
                name: 'startTime',
                type: 'DatetimePicker',
                label: 'Início do período de recorrência',
                mode: 'time',
                isEnabled({ showRecurrence }) {
                  return showRecurrence;
                },
              },
              {
                name: 'endTime',
                type: 'DatetimePicker',
                label: 'Fim do período de recorrência',
                mode: 'time',
                isEnabled({ showRecurrence }) {
                  return showRecurrence;
                },
              },
            ],
          },
          {
            name: 'config',
            label: 'Configurações avançadas',
            fields: [
              {
                name: 'zIndex',
                label: 'z-index',
                helpText:
                  'O pop-up com maior z-index irá aparecer na frente dos demais caso hajam múltiplos',
                type: 'ShortText',
                mask: {
                  mask: Number,
                },
              },
            ],
          },
          {
            name: 'visibility',
            label: 'Visibilidade',
            fields: [
              {
                name: 'showOnDesk',
                type: 'Checkbox',
                label: 'Exibir no desktop',
              },
              {
                name: 'showOnMobile',
                type: 'Checkbox',
                label: 'Exibir no mobile',
              },
            ],
          },
        ],
      },
    ],
  },
};
</script>
